import {
  createReceipt,
  receiptsList,
  invoiceReceipt
} from '@/febos/servicios/api/aduanas/receipts.api';

export const selectReceiptState = ({ commit }, receipt) => {
  commit('SET_SELECTED_RECEIPT', receipt);
};
export const fetchReceiptsList = async ({ commit }, data) => {
  try {
    commit('SET_RECEIPTS_LIST', {});
    commit('SET_LOADING', true);
    const response = await receiptsList(data);
    commit('SET_RECEIPTS_LIST', response.data);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const selectAllElements = ({ commit }, isSelected) => {
  commit('MARK_SELECTED_RECEIPTS', isSelected);
};

export const createNewReceipt = async ({ commit }, receipt) => {
  try {
    commit('SET_LOADING', true);
    const response = await createReceipt(receipt);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};
export const getReceiptDetails = ({ commit }, id) => {
  commit('SET_DETAILS_RECEIPT', id);
};

export const searchAllReceipts = ({ commit }, receipts) => {
  commit('SET_DETAILS_SELECTED_RECEIPTS', receipts);
};

export const attemptInvoiceReceipt = async ({ commit }, { receiptId, issueDate, preview }) => {
  try {
    commit('SET_LOADING', true);
    const response = await invoiceReceipt({ receiptId, issueDate, preview });
    if (preview !== 'si') {
      commit('UPDATE_STATUS_RECEIPT', { receiptId, issueDate, preview });
    }
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};
